<script setup>
import LegalPage from '@/components/legal/LegalPage.vue'
</script>

<template>
    <Head>
        <title>Ochrana soukromí</title>
        <meta
            name="description"
            content="Zásady zpracování osobních údajů ve společnosti SolveCount s.r.o. v souladu s GDPR."
        />
    </Head>

    <LegalPage
        title="Ochrana soukromí"
        updated-at="2026-05-22"
    >
        <p>
            Tyto zásady popisují, jak společnost <strong>SolveCount s.r.o.</strong> (dále jen „Správce") zpracovává
            osobní údaje, které získá od návštěvníků webu solvecount.cz a od klientů svých služeb.
        </p>

        <h2>1. Správce osobních údajů</h2>

        <p>
            <strong>SolveCount s.r.o.</strong>, IČO 22547070, se sídlem Kurzova 2222/16, Stodůlky, 155 00 Praha 5,
            zapsaná v obchodním rejstříku vedeném Městským soudem v Praze, oddíl C, vložka 418257.
        </p>

        <p>Jednatelé: Adam Žáček a Ing. Kristýna Zavadilová.</p>

        <p>
            Kontakt:
            <a href="mailto:solvecount@gmail.com">solvecount@gmail.com</a>
        </p>

        <h2>2. Jaké údaje zpracováváme</h2>

        <ul>
            <li><strong>Identifikační údaje</strong> — jméno, příjmení, název společnosti, IČO, DIČ</li>
            <li><strong>Kontaktní údaje</strong> — e-mail, telefon, adresa</li>
            <li><strong>Účetní a daňové údaje</strong> klientů v rámci plnění smluvních povinností</li>
            <li>
                <strong>Technické údaje</strong> — IP adresa, typ prohlížeče (pouze v rozsahu nezbytném pro provoz webu)
            </li>
        </ul>

        <h2>3. Účely a právní základ zpracování</h2>

        <ul>
            <li>
                <strong>Plnění smlouvy</strong> (čl. 6 odst. 1 písm. b) GDPR) — poskytování účetních a daňových služeb
            </li>
            <li>
                <strong>Plnění právní povinnosti</strong> (čl. 6 odst. 1 písm. c) GDPR) — archivace dokladů dle zákona
                č. 563/1991 Sb. o účetnictví
            </li>
            <li>
                <strong>Oprávněný zájem</strong> (čl. 6 odst. 1 písm. f) GDPR) — vyřízení poptávky odeslané přes
                kontaktní formulář
            </li>
        </ul>

        <h2>4. Doba uchování</h2>

        <p>
            Účetní doklady uchováváme po dobu stanovenou platnými zákony (zpravidla 10 let). Kontaktní údaje z webové
            poptávky uchováváme maximálně 2 roky od poslední komunikace.
        </p>

        <h2>5. Vaše práva</h2>

        <ul>
            <li>Právo na přístup k osobním údajům</li>
            <li>Právo na opravu nepřesných údajů</li>
            <li>Právo na výmaz („právo být zapomenut")</li>
            <li>Právo na omezení zpracování</li>
            <li>Právo na přenositelnost údajů</li>
            <li>Právo vznést námitku proti zpracování</li>
            <li>Právo podat stížnost u Úřadu pro ochranu osobních údajů</li>
        </ul>

        <h2>6. Předávání údajů třetím stranám</h2>

        <p>
            Vaše údaje předáváme pouze v rozsahu nezbytném pro plnění služby (finanční úřad, správa sociálního
            zabezpečení, zdravotní pojišťovny) nebo zpracovatelům, se kterými máme uzavřenou smlouvu o zpracování
            (poskytovatel účetního software, hosting webu).
        </p>

        <h2>7. Kontakt pro uplatnění práv</h2>

        <p>
            Pro uplatnění svých práv nebo jakékoliv dotazy k ochraně osobních údajů nás kontaktujte na
            <a href="mailto:solvecount@gmail.com">solvecount@gmail.com</a>.
        </p>

        <p class="mt-12 text-sm text-zinc-500">
            Tento dokument je šablona — před spuštěním nechte zkontrolovat advokátem pro váš konkrétní rozsah činností.
        </p>
    </LegalPage>
</template>
